import React from 'react';
import PortalPage from './PortalPage';

const EmployeePortal = () => <PortalPage audience="employee" />;

export default EmployeePortal;
